import { Component } from '@angular/core';

/**
 * Component.
 */
@Component({
	selector: 'copyright',
	template: `
			<div class="EmptyBox5"></div>
		<div class="WidAutoOnMobile White" style="
		background: rgba(255, 255, 255, .2); border-radius: 4px;" >
					<div class="EmptyBox5"></div>
	<p style="padding: 0px 10px 0px 10px">
				<i class="fa fa-copyright"></i> 2014–2025 food safety qualITy GmbH
					<br /> Alle Rechte vorbehalten.
			</p>
			<div class="EmptyBox10"></div>
		</div>
		`
})
export class CopyrightComponent {
}

